/* esm.sh - unhead@3.1.0/dist/shared/unhead.ebqUBTt1 */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.ebqUBTt1.mjs";
